var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-views',{attrs:{"toolbar-through":""}},[_c('Login-page'),_c('f7-view',{attrs:{"main":""}},[_c('Left-panel'),_c('Store-page'),_c('Popup-page',{attrs:{"count":_vm.userInfo.clientList.length}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }